export function openMenu() {
  return { type: 'MENU_OPEN_STATE', isOpen: true };
}

export function closeMenu() {
  return { type: 'MENU_OPEN_STATE', isOpen: false };
}



// WEBPACK FOOTER //
// ./src/actions/menu.js